import script from "./ADLTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ADLTable.vue?vue&type=script&setup=true&lang=js"

import "./ADLTable.vue?vue&type=style&index=0&id=5a47c087&lang=less&scoped=true"

import exportComponent from "D:\\A-Project\\nezha_business\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a47c087"]])

export default __exports__